__turbopack_context__.v({
  "button": "Button-module__C4b5yW__button",
  "colourBlack": "Button-module__C4b5yW__colourBlack",
  "colourBlue": "Button-module__C4b5yW__colourBlue",
  "colourGreen": "Button-module__C4b5yW__colourGreen",
  "colourGrey": "Button-module__C4b5yW__colourGrey",
  "colourWhite": "Button-module__C4b5yW__colourWhite",
  "icon": "Button-module__C4b5yW__icon",
  "label": "Button-module__C4b5yW__label",
  "sizeLabel": "Button-module__C4b5yW__sizeLabel",
  "sizeLarge": "Button-module__C4b5yW__sizeLarge",
  "sizeMedium": "Button-module__C4b5yW__sizeMedium",
  "variantPrimary": "Button-module__C4b5yW__variantPrimary",
  "variantSecondary": "Button-module__C4b5yW__variantSecondary",
  "variantTertiary": "Button-module__C4b5yW__variantTertiary",
});
